import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import { DynamicScriptLoaderServiceService } from './_services/dynamic-script-loader-service.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'client';
  href = '';
  urlList: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    // console.log('configured routes: ', this.router.config);
    

    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/slimScroll/jquery.slimscroll.min.js');
   // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom1.js?n=1');

    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
        //  DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/slimScroll/jquery.slimscroll.min.js');
          DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom1.js?n=1');
        }
      });
    //DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/slimScroll/jquery.slimscroll.min.js');


    this.href = this.router.url;
  }


}
